var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenVi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74998 15.5C12.0302 15.5 15.5 12.0302 15.5 7.74998C15.5 3.46978 12.0302 0 7.74998 0C3.46978 0 0 3.46978 0 7.74998C0 12.0302 3.46978 15.5 7.74998 15.5ZM7.74998 14.5C4.04174 14.5 0.999998 11.4983 0.999998 7.74998C0.999998 4.04177 4.0017 0.999998 7.74998 0.999998C11.4582 0.999998 14.5 4.0017 14.5 7.74998C14.5 11.4582 11.4983 14.5 7.74998 14.5ZM6.53593 11.5022L12.1759 5.90746C12.3229 5.76161 12.3239 5.52419 12.178 5.37715L11.9139 5.11089C11.7681 4.96386 11.5307 4.96294 11.3836 5.10878L6.27611 10.1753L4.12063 8.00242C3.97478 7.85539 3.73733 7.85444 3.59029 8.00029L3.32406 8.26439C3.17702 8.41023 3.17608 8.64765 3.32192 8.79469L6.0056 11.5001C6.15144 11.6471 6.3889 11.648 6.53593 11.5022Z",
    fill: "#20662E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenVi);
export default __webpack_public_path__ + "static/media/GreenVi.99ea51491806b2f2be32b599b8bacc5f.svg";
export { ForwardRef as ReactComponent };